import {inject, Injectable} from '@angular/core';
import {Message, MessageService} from 'primeng/api';

/**
 * Buffers PrimeNG toast messages until the toast component is ready
 * Solves timing issues when messages need to be shown during app initialization
 */
@Injectable({
  providedIn: 'root'
})
export class BufferedMessageService {

  private readonly messageService = inject(MessageService);

  private readonly buffer: Message[] = [];
  private ready = false;

  /**
   * Adds a message to the queue
   * If toast is ready, shows immediately; otherwise buffers it
   */
  add(message: Message) {
    if (this.ready) {
      this.messageService.add(message);
    } else {
      this.buffer.push(message);
    }
  }

  /**
   * Marks the service as ready and flushes buffered messages
   * Should be called after toast component is rendered (e.g., in ngAfterViewInit)
   */
  markReady() {
    if (this.ready) {
      console.warn('BufferedMessageService already marked as ready');
      return;
    }

    this.ready = true;
    this.buffer.forEach(m => this.messageService.add(m));
    this.buffer.length = 0;
  }
}
